import { createFileRoute } from '@tanstack/react-router';
import { AdminQuotesPage } from '@/features/admin/admin-quotes-page';

export const Route = createFileRoute('/gm/quotes/')({
  component: GmQuotesIndexRoute,
});

function GmQuotesIndexRoute() {
  return <AdminQuotesPage actionHrefBase="/gm/quotes" portalBase="/gm" />;
}
